import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { Icon } from "@iconify/react";
import { AwardsPageContent } from "./AwardsPageContent";
import { AwardsPageHeading } from "./AwardsPageHeading";
import { AwardsNewsNextPage } from "./AwardsNewsNextPage";


export const Awards = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  useEffect(() => {
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/awards?activeTab=awardsPageHeading`, {
          replace: true,
        });
    }
  }, []);

  const items = [
    {
      label: "Page Heading",
      key: "awardsPageHeading",
      children:<AwardsPageHeading/>
    },
    {
      label: "Page Content",
      key: "awardsPageContent",
      children: <AwardsPageContent/>
    },
    {
      label: "Next Page",
      key: "awardsNextPage",
      children: <AwardsNewsNextPage/>
    },
  ];

  return (
    <ContentWrapper
           title="Awards"
           actionItems={
            query.get("activeTab") === "awardsPageContent" && (
            <Button
              onClick={() => {
                if (query.get("activeTab") === "awardsPageContent") {
                  navigate("/dedicated/corporate/awards/add");
                }
              }}
              icon={<Icon icon={"lucide:plus"} />}
            >
              Add Award
            </Button>)}
          >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
